import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/UnderstandingTest/CaikumaElated.svg?webp&width=200'


const _withScopeId = n => (_pushScopeId("data-v-2e1690c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container bg-white" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "\n      理解度テスト\n    ", -1))
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"content\" data-v-2e1690c7><div class=\"large-title\" data-v-2e1690c7>\n        CLEAR\n      </div> <div class=\"description\" data-v-2e1690c7>\n        理解度テストのクリア、おめでとうございます！<br data-v-2e1690c7>\n        ルールを守って気持ちの良いカイテクワークを楽しんでください。<br data-v-2e1690c7>\n        ご不明点があればお気軽に運営事務局までお問い合わせください。\n      </div> <div class=\"image\" data-v-2e1690c7><img src=\"" + _imports_0 + "\" data-v-2e1690c7></div></div>", 1)
const _hoisted_4 = { class: "footer bg-white" }

import { computed } from "vue";
import { useRoute } from "vue-router";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { authStore } from "@/store/auth";
import { useCustomRouter } from "@/utils/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'UnderstandingTestFinish',
  setup(__props) {

const route = useRoute();
const { replaceIgnoreError } = useCustomRouter();

const orderId = computed(() => Number(route.params["orderId"]));
const workTimeOptionId = computed(() =>
  Number(route.params["workTimeOptionId"])
);

async function onClickNext() {
  authStore.setShouldRequireUnderstandingTest(false);
  await replaceIgnoreError({
    name: "OrdersLastConfirmation",
    params: {
      orderId: orderId.value.toString(),
      workTimeOptionId: workTimeOptionId.value.toString()
    }
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createTextVNode(),
    _hoisted_3,
    _createTextVNode(),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(AppButton, {
        block: "",
        class: "button",
        onClick: onClickNext
      }, {
        default: _withCtx(() => [
          _createTextVNode("最終確認へ")
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})